<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :model="model"
    :rules="{}"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section
        :title="$t('GoogleAnalyticsSettings_Integration_Title')"
        :description="$t('GoogleAnalyticsSettings_Integration_Description')"
      >
        <rest-form-item prop="is_ga">
          <toggle
            v-model="model.is_ga"
            :text="$t('GoogleAnalyticsSettings_Enable')"
          />
        </rest-form-item>

        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('GoogleAnalyticsSettings_Field_Email')"
              prop="email"
            >
              <el-input v-model="model.ga_email" />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              prop="ga_certificate"
              :label="$t('GoogleAnalyticsSettings_Field_Certificate')"
            >
              <certificate-upload
                :value="model.ga_certificate"
                :file.sync="model.ga_certificate_key"
                :password.sync="model.ga_certificate_password"
                default-password="notasecret"
              />
            </rest-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <rest-form-item
              :label="$t('GoogleAnalyticsSettings_Field_Profile_ID')"
              prop="ga_profile_id"
            >
              <el-input v-model="model.ga_profile_id" />
            </rest-form-item>
          </el-col>

          <el-col :span="12" style="display: flex">
            <rest-form-item
              prop="ga_dimension"
              :label="$t('GoogleAnalyticsSettings_Field_Dimension')"
              style="margin-right: 10px"
            >
              <el-input
                placeholder="create automatically"
                v-model="model.ga_dimension"
              >
                <template slot="prepend">
                  {{ $t('GoogleAnalyticsSettings_Dimension') }}
                </template>
              </el-input>
            </rest-form-item>

            <rest-form-item
              prop="ga_dimension_readonly"
              :label="$t('GoogleAnalyticsSettings_Field_DimensionReadonly')"
            >
              <toggle v-model="model.ga_dimension_readonly" spaced />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import CertificateUpload from '@/common/components/form/CertificateUpload'
import Toggle from '@/common/components/form/Toggle'

export default {
  name: 'GaSettingsPage',

  components: {
    Toggle,
    RestFormPage,
    RestFormItem,
    FormSection,
    CertificateUpload
  },

  mounted() {
    this.$message({
      customClass: 'ga-warning',
      message: this.$t('GoogleAnalyticsSettings_WarningMsg'),
      type: 'warning',
      duration: 15000,
      dangerouslyUseHTMLString: true
    })
  },

  data() {
    return {
      model: this.defaultModel()
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      if (this.$route.query.project_id) {
        return {
          method: 'get',
          url: `projects/${this.$route.query.project_id}`,
          params: {
            expand:
              'ga_email,ga_profile_id,ga_certificate,ga_dimension,ga_dimension_readonly'
          },
          handler: data => {
            this.model = data
          }
        }
      } else {
        return null
      }
    },

    saveEndpoint() {
      if (this.$route.query.project_id) {
        return {
          method: 'patch',
          url: `projects/${this.$route.query.project_id}`
        }
      } else {
        return {
          method: 'post',
          url: `projects`
        }
      }
    },

    readonly() {
      // TODO: this page will be deleted in XP-6314
      return !this.$can('manageProjectTechnical') || true
    }
  },

  methods: {
    defaultModel() {
      if (this.$route.query.project_id) {
        return null
      } else {
        return {
          region: this.$store.state.app.region
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/GaSettingsPage.vue